import React from 'react'
import { Alert } from '@mui/material'
import Snackbar from '@mui/material/Snackbar'
import { AlertColor } from '@mui/material/Alert'

type Props = {
    message: string
    severity: AlertColor
    sx: object
    open: boolean
    onClose: () => void
}

export const SnackbarAlert = ({ message, severity, sx, open, onClose }: Props) => {
    const sxProps = Object.keys(sx).length
        ? sx
        : {
              '&.MuiSnackbar-root': {
                  position: 'absolute',
                  zIndex: 1000,
                  top: '55px',
                  right: '260px',
                  bottom: 'inherit',
                  left: 'inherit',
              },
          }
    return (
        <>
            <Snackbar open={open} onClose={onClose} autoHideDuration={5000} sx={sxProps}>
                <Alert onClose={onClose} severity={severity} sx={{ borderRadius: '12px' }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    )
}
